module.exports = __webpack_public_path__ + "static/img/14.d4a1610.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/14.jpeg
// module id = xxTP
// module chunks = 3